import React, { Component } from 'react'
import { connect } from 'react-redux'

import postBVFeedback from '../../actionCreators/bazaarVoiceFeedback/bazaarVoiceFeedbackActionCreators'

import BazaarVoiceHelpfulness from './BazaarVoiceHelpfulness'

class BazaarVoiceHelpfulnessContainer extends Component {
  render = () => <BazaarVoiceHelpfulness {...this.props} />
}

const mapDispatchToProps = dispatch => {
  const props = {
    postFeedback: payload => dispatch(postBVFeedback(payload))
  }
  return props
}

export default connect(null, mapDispatchToProps)(BazaarVoiceHelpfulnessContainer)
export { BazaarVoiceHelpfulnessContainer, mapDispatchToProps }
